export default __webpack_public_path__ + "static/media/stuff.aa9c753a.svg";